import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
//引入 vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import {
  Toast
} from 'vant';
Vue.use(Toast);
//引入axios
import axios from 'axios';
Vue.prototype.axios = axios;

//引md5
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
Vue.prototype.$selectInfo = '';
//埋点
import sensors from './api/sensors.js'
Vue.prototype.$sensors = sensors
// import 'amfe-flexible'
// //引入lib-flexible
import 'lib-flexible/flexible'
// import 'lib-flexible'
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  next()
})
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import VueTouch from 'vue-touch'

Vue.use(VueTouch, {name: 'v-touch'})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')